const Domains  = [
  {
    domain: ['www.theglobalgenie.com'],
    code: 'IN'
  },
];

export default Domains;